// extracted by mini-css-extract-plugin
module.exports = {"ipad_tips_box":"IPadTips_ipad_tips_box__79WRa"};